import React, {createContext, useContext, useState} from 'react'
import {TabsContainer, TabItem} from './GradientTabs.styles'

const GradientTabsContext = createContext(null)

export function GradientTabs({
  children,
  activeTab,
  onChange,
  defaultTab,
  borderColor,
  activeBackground,
  variant,
}) {
  const [internalTab, setInternalTab] = useState(defaultTab)
  const isControlled = activeTab !== undefined
  const currentTab = isControlled ? activeTab : internalTab

  const handleChange = id => {
    if (!isControlled) setInternalTab(id)
    onChange?.(id)
  }

  return (
    <GradientTabsContext.Provider
      value={{currentTab, handleChange, borderColor, activeBackground, variant}}
    >
      <TabsContainer>{children}</TabsContainer>
    </GradientTabsContext.Provider>
  )
}

export function GradientTab({id, children}) {
  const {currentTab, handleChange, borderColor, activeBackground, variant} =
    useContext(GradientTabsContext)

  return (
    <TabItem
      active={currentTab === id}
      borderColor={borderColor}
      activeBackground={activeBackground}
      variant={variant}
      onClick={() => handleChange(id)}
    >
      {children}
    </TabItem>
  )
}
